import { createFeatureSelector, createSelector } from "@ngrx/store";
import { examFeatureKey, ExamState } from "../reducers/exam.reducer";

export const selectExamState = createFeatureSelector<ExamState>(examFeatureKey);

export const selectExams = createSelector(
  selectExamState,
  (state: ExamState) => state.exams
);
